<template>
  <div>
    <el-card shadow="hover">
      <template slot="header">
        <div class="clearfix">
          <span>出库类型管理</span>
          <span class="muted small" style="margin-left:10px">在某个商品分类下维护可选的出库类型（用于出库管理新建）</span>
          <div style="float: right">
            <el-button type="primary" size="small" icon="el-icon-plus" @click="openDialog()">新建出库类型</el-button>
          </div>
        </div>
      </template>

      <el-form :inline="true" :model="searchForm" class="mb-4">
        <el-form-item label="类型（商品分类）">
          <el-select v-model="searchForm.categoryId" placeholder="全部" clearable style="width: 200px" @change="loadList">
            <el-option v-for="c in categoryList" :key="c.id" :label="c.name" :value="c.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <el-table :data="rows" stripe size="small" border v-loading="loading" @row-dblclick="row => openDialog(row)">
        <el-table-column label="排序" prop="sort" width="80" align="center"></el-table-column>
        <el-table-column label="类型（商品分类）" min-width="160">
          <template slot-scope="{ row }">
            <el-tag size="small">{{ categoryName(row.categoryId) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="出库类型名称" min-width="180">
          <template slot-scope="{ row }">
            <span>{{ row.name }}</span>
            <el-tag v-if="isProtected(row)" size="mini" type="warning" effect="plain" style="margin-left: 8px">系统内置</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag size="mini" :type="row.enabled === 1 ? 'primary' : 'info'" effect="plain">{{ row.enabled === 1 ? '启用' : '停用' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column label="创建时间" width="160" align="center">
          <template slot-scope="{ row }">{{ formatDate(row.createTime) }}</template>
        </el-table-column>
        <el-table-column label="ID" prop="id" width="80" align="center"></el-table-column>
        <el-table-column label="操作" width="160" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button size="mini" type="primary" @click="openDialog(row)">编辑</el-button>
            <template v-if="isProtected(row)">
              <el-tooltip content="系统内置类型，不可删除" placement="top">
                <span style="display:inline-block; margin-left:8px;">
                  <el-button size="mini" type="danger" disabled>删除</el-button>
                </span>
              </el-tooltip>
            </template>
            <template v-else>
              <el-button size="mini" type="danger" style="margin-left:8px;" @click="onDelete(row)">删除</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog :title="form.id ? (isProtectedForm ? '编辑出库类型（系统内置）' : '编辑出库类型') : '新建出库类型'" :visible.sync="dialogVisible" width="880px" top="6vh" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-alert
        v-if="isProtectedForm"
        title="系统内置出库类型：分类与名称不可修改，可调整排序与备注。"
        type="info"
        :closable="false"
        show-icon
        style="margin-bottom: 18px"
      />
      <el-form :model="form" :rules="rules" ref="form" label-width="120px">
        <el-form-item label="类型（商品分类）" prop="categoryId">
          <el-select v-model="form.categoryId" placeholder="选择商品分类" style="width:100%" :disabled="isProtectedForm">
            <el-option v-for="c in categoryList" :key="c.id" :label="c.name" :value="c.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出库类型名称" prop="name">
          <el-input v-model="form.name" placeholder="如 试饮、赠送、报损 等" maxlength="50" :disabled="isProtectedForm"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sort" :min="0" :step="1" style="width:100%"></el-input-number>
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="form.enabled" :active-value="1" :inactive-value="0" active-text="启用" inactive-text="停用"></el-switch>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="2" maxlength="500" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="onSubmit" :loading="submitting">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'OutboundType',
  data() {
    return {
      rows: [],
      loading: false,
      categoryList: [],
      searchForm: { categoryId: null },
      dialogVisible: false,
      submitting: false,
      form: this.emptyForm(),
      rules: {
        categoryId: [{ required: true, message: '请选择类型（商品分类）', trigger: 'change' }],
        name: [{ required: true, message: '请输入出库类型名称', trigger: 'blur' }]
      }
    }
  },
  computed: {
    isProtectedForm() {
      return !!(this.form && this.form.id && this.isProtected(this.form))
    }
  },
  mounted() {
    this.loadCategories()
    this.loadList()
  },
  methods: {
    emptyForm() {
      return { id: null, name: '', categoryId: null, sort: 0, enabled: 1, remark: '' }
    },
    loadCategories() {
      axios.get('/category/list').then(res => { this.categoryList = Array.isArray(res.data) ? res.data : [] })
    },
    loadList() {
      this.loading = true
      const params = {}
      if (this.searchForm.categoryId) params.categoryId = this.searchForm.categoryId
      axios.get('/outbound-type/list', { params }).then(res => {
        this.rows = Array.isArray(res.data) ? res.data : []
      }).finally(() => { this.loading = false })
    },
    categoryName(id) {
      const c = this.categoryList.find(x => x.id === id)
      return c ? c.name : (id || '—')
    },
    isProtected(row) {
      if (!row || !row.name) return false
      const catName = this.categoryName(row.categoryId)
      const isProductCategory = catName === '产品' || row.categoryId === 2
      if (!isProductCategory) return false
      const protectedNames = ['产品试用', '新出库', '送存货', '尊贵卡A', '尊贵卡B', '尊贵卡C', '尊贵卡a', '尊贵卡b', '尊贵卡c']
      return protectedNames.includes(String(row.name).trim())
    },
    openDialog(row) {
      this.loadCategories()
      this.form = row ? { ...row } : this.emptyForm()
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.submitting = true
        const req = this.form.id ? axios.put('/outbound-type', this.form) : axios.post('/outbound-type', this.form)
        req.then(res => {
          if (res.data && res.data.success !== false) {
            this.$message.success(this.form.id ? '更新成功' : '新建成功')
            this.dialogVisible = false
            this.loadList()
          } else {
            this.$message.error((res.data && res.data.message) || '保存失败')
          }
        }).finally(() => { this.submitting = false })
      })
    },
    onDelete(row) {
      if (this.isProtected(row)) {
        this.$message.warning('系统内置出库类型「' + row.name + '」不允许删除')
        return
      }
      this.$confirm('确定删除出库类型「' + row.name + '」？', '提示', { type: 'warning' }).then(() => {
        axios.delete('/outbound-type/' + row.id).then(res => {
          if (res.data && res.data.success !== false) {
            this.$message.success('删除成功')
            this.loadList()
          } else {
            this.$message.error((res.data && res.data.message) || '删除失败')
          }
        })
      }).catch(() => {})
    },
    formatDate(v) { return v ? String(v).replace('T', ' ').slice(0, 10) : '-' }
  }
}
</script>

<style scoped>
.muted { color: #909399; }
.small { font-size: 12px; }
.mb-4 { margin-bottom: 16px; }
</style>
